import React, { useState } from "react";
import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

//@ts-ignore

import { PlayerModule as AnalyticsModule } from "bitmovin-analytics";
import { PlayerEvent, Player } from "bitmovin-player";

//@ts-ignore

import { Box } from "@mui/material";
import useCommonDetails from "../../Common/Hooks/useCommonDetails";
import useConfig from "../../hooks/useConfig";

declare global {
  interface Window {
    bitmovin: any;
  }
}

interface bitMovingPlayerProps {
  playerRef: any;
  currentVideoData: any;
  videoList: any[];
  videoUrl: string;
  setPage: any;
  page: any;
  setCurrentVideo: any;
  pageData: any;
}
const HighlightPlayer: React.FC<bitMovingPlayerProps> = ({
  playerRef,
  currentVideoData,
  videoList,
  setPage,
  page,
  videoUrl,
  setCurrentVideo,
  pageData,
}) => {
  const userDetails = useCommonDetails();
  const configData = useConfig();
  const { id } = useParams();
  const playerId = configData.jwPlayerID;
  // Event handler for seek end

  useEffect(() => {
    // Function to initialize JW Player
    if (videoUrl) {
      var conf: any = {
        key: configData?.bitMovinKey,
        location: {
          ui: "https://cdn.jsdelivr.net/npm/bitmovin-player-ui@4/dist/js/bitmovinplayer-ui.js",
          ui_css:
            "https://cdn.jsdelivr.net/npm/bitmovin-player-ui@4/dist/css/bitmovinplayer-ui.css",
        },
        style: {
          uiManagerFactory: (playerAPI: any, config: any) => {
            // Use the new UIFactory method to build the UI
            return new window.bitmovin.playerui.UIFactory.buildUI(
              playerAPI,
              config
            );
          },
        },
        ...(currentVideoData?.Title && {
          analytics: {
            key: configData.analysticBitmovinKey,

            title: `${currentVideoData?.Title} - ${currentVideoData?.Description}`,

            videoId: `highlight_${currentVideoData?.ID}`,
            customUserId: userDetails.UserID,
            customVideoType: "Highlight",
          },
        }),

        playback: {
          autoplay: true,
        },
        cast: {
          enable: true,
        },
      };

      var source = {
        hls: videoUrl,
      };
      Player.addModule(AnalyticsModule);
      playerRef.current = new Player(
        document.getElementById("linus-bitmovin-player") as any,
        conf
      );

      // Setup the player
      playerRef.current.load(source).then(() => {});

      playerRef.current.on(PlayerEvent.PlaybackFinished, () => {
        const findIndex = videoList.findIndex(
          (el: any) => el.ID == currentVideoData?.ID
        );
        if (
          pageData.totalPage === pageData.page &&
          findIndex === videoList.length - 1
        ) {
          setPage(1);
          return;
        } else if (findIndex === videoList.length - 1) {
          setPage(page + 1);

          return;
        } else {
          setCurrentVideo(videoList[findIndex + 1]);
          return;
        }
      });

      return () => {
        playerRef.current.unload();
      };
    }
  }, [playerId, videoUrl, videoList, currentVideoData, id]);

  return (
    <Box sx={{ position: "relative" }}>
      <Box className="player-container" id={"linus-bitmovin-player"}></Box>
    </Box>
  );
};

export default HighlightPlayer;
